import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="collapse"
export default class extends Controller {
  static targets = ["content", "icon"]
  static values = { expanded: {
    type: Boolean,
    default: false
  } }
  connect() {
  }

  toggle(e) {
    e?.preventDefault();
    this.expandedValue = !this.expandedValue;
    if (this.expandedValue) {
      this.expand();
    } else {
      this.collapse();
    }
  }

  expand() {
    if (this.hasIconTarget) {
      this.iconTarget.classList.remove('rotate-0');
      this.iconTarget.classList.add('rotate-180');
    }
    this.contentTarget.classList.remove('hidden');
  }

  collapse() {
    if (this.hasIconTarget) {
      this.iconTarget.classList.remove('rotate-180');
      this.iconTarget.classList.add('rotate-0');
    }
    this.contentTarget.classList.add('hidden');
  }
}
